import React from 'react';
import RosterServiceList from './RosterServiceList';
import RosterSummary from './RosterSummary';
import RosterTeamLoad from './RosterTeamLoad';
import RosterToolbar from './RosterToolbar';
import { formatRosterMonth, getMonthRelation } from './rosterUtils';

const WorshipRosterSection = ({
  year,
  month,
  summary,
  canManage,
  publishing,
  onPreviousMonth,
  onNextMonth,
  onToday,
  onOpenService,
  onPublish,
}) => {
  const services = summary?.services || [];
  const members = summary?.members || [];
  const isCurrentMonth = getMonthRelation(year, month) === 'current';

  return (
    <div className="space-y-5">
      <header className="flex flex-col gap-4 border-b border-slate-200 pb-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Maandrooster</h1>
          <p className="mt-1 max-w-2xl text-sm text-slate-500">Alle diensten deze maand, de planningsbelasting per teamlid en publiceren met één klik.</p>
        </div>
        <RosterToolbar
          year={year}
          month={month}
          onPrevious={onPreviousMonth}
          onNext={onNextMonth}
          onToday={onToday}
          isCurrentMonth={isCurrentMonth}
        />
      </header>

      <RosterSummary services={services} canManage={canManage} publishing={publishing} onPublish={onPublish} />

      <div className="grid items-start gap-7 lg:grid-cols-12">
        <section className="space-y-3 lg:col-span-8" aria-labelledby="roster-services-heading">
          <div>
            <h2 id="roster-services-heading" className="text-base font-semibold text-slate-900">Dienstplanning</h2>
            <p className="mt-1 text-sm text-slate-500">{formatRosterMonth(year, month)}</p>
          </div>
          <RosterServiceList services={services} year={year} month={month} onOpen={onOpenService} />
        </section>
        <aside className="lg:col-span-4">
          <RosterTeamLoad members={members} overrides={summary?.overrides || []} />
        </aside>
      </div>
    </div>
  );
};

export default WorshipRosterSection;

